export default "__VITE_ASSET__DH4A4Ncx__"